import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import Datepicker from 'vuejs-datepicker';
import VOffline from 'v-offline';
import Blank from '@/layouts/Blank';
import Default from '@/layouts/Default';
import AppUtility from '@/resources/Utility';
import Constants from '@/resources/Constants';
import LoaderSpinner from '@/components/utility/LoaderSpinner';
import SwitchButton from '@/components/utility/SwitchButton';
import Checkbox from '@/components/utility/Checkbox';
import InputDot from '@/components/utility/InputDot';
import TakePicture from '@/components/utility/TakePicture';
import ModalFullPicture from '@/components/utility/ModalFullPicture';
import Dropdown from "@/components/utility/Dropdown";
import Typeahead from "@/components/utility/Typeahead";
import Paging from '@/components/utility/Paging';
import '@/registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/theme/Core.scss';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);
Vue.use(PerfectScrollbar);
Vue.use(AppUtility);
Vue.use(Constants);

Vue.component('datepicker', Datepicker);
Vue.component('v-offline', VOffline);
Vue.component('blank-layout', Blank);
Vue.component('default-layout', Default);
Vue.component('loader-spinner', LoaderSpinner);
Vue.component('switch-button', SwitchButton);
Vue.component('checkbox', Checkbox);
Vue.component('input-dot', InputDot);
Vue.component('take-picture', TakePicture);
Vue.component('modal-full-picture', ModalFullPicture);
Vue.component('dropdown', Dropdown);
Vue.component('typeahead', Typeahead);
Vue.component('paging', Paging);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
